import React, { useEffect, useState } from "react";
import { PaperBG } from "../kits";

// Material-Editor als Modal
function MaterialEditor({ reg, onClose, onSaved }) {
  const [fields, setFields] = useState({
    teams_link: reg.teams_link || "",
    software_access: reg.software_access || "",
    video_links: reg.video_links || "",
    personal_notes: reg.personal_notes || "",
    day_plan_json: reg.day_plan_json || ""
  });
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    // JSON check
    try {
      if (fields.day_plan_json.trim() !== "") JSON.parse(fields.day_plan_json);
    } catch {
      alert("❗Tagesplan JSON ist kein gültiger JSON-Text");
      return;
    }
    setSaving(true);

    // Zusammenstellen, was gebraucht wird
    const payload = {
      registration_id: reg.registration_id,
      course_id: reg.course_id,
      user_id: reg.user_id,
      ...fields,
      teams_link: normalizeTeamsLink(fields.teams_link)
    };
    if (reg.material_id) payload.material_id = reg.material_id;

    const url = "https://www.denisbitter.de/stage01/api/save_user_course_material.php";
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      setSaving(false);
      if (data.success) {
        alert("Material gespeichert!");
        onSaved(); // Reload parent list
      } else {
        alert("Fehler beim Speichern: " + data.error);
      }
    } catch (e) {
      setSaving(false);
      alert("Fehler beim Speichern: " + e.message);
    }
  }

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 space-y-4 w-full max-w-lg mx-auto font-mono relative">
        <button
          className="absolute top-2 right-2 text-gray-300 hover:text-slate-50 text-xl"
          onClick={onClose}
          disabled={saving}
        >×</button>
        <div className="font-bold text-lg mb-2 text-brand">
          Material für {reg.first_name} {reg.name} ({reg.course_title})
        </div>
        <input
          className="w-full p-2 rounded bg-gray-700"
          placeholder="Teams Link"
          value={fields.teams_link}
          onChange={e => 
            setFields(f => ({
      ...f,
      teams_link: normalizeTeamsLink(e.target.value)
    }))
  }
        />
        <input
          className="w-full p-2 rounded bg-gray-700"
          placeholder="Software Access"
          value={fields.software_access}
          onChange={e => setFields(f => ({ ...f, software_access: e.target.value }))}
        />
        <input
          className="w-full p-2 rounded bg-gray-700"
          placeholder="Video Links (JSON String)"
          value={fields.video_links}
          onChange={e => setFields(f => ({ ...f, video_links: e.target.value }))}
        />
        <textarea
          className="w-full p-2 rounded bg-gray-700"
          placeholder="Notizen"
          value={fields.personal_notes}
          onChange={e => setFields(f => ({ ...f, personal_notes: e.target.value }))}
        />
        <textarea
          className="w-full p-2 rounded bg-gray-700"
          placeholder="Day Plan JSON"
          value={fields.day_plan_json}
          onChange={e => setFields(f => ({ ...f, day_plan_json: e.target.value }))}
        />
        <button
          className="bg-green-500 hover:bg-green-600 text-black py-2 px-4 rounded w-full font-bold"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Speichert..." : "Speichern"}
        </button>
        <button
          className="bg-gray-600 hover:bg-gray-700 text-slate-50 py-2 px-4 rounded w-full mt-2"
          onClick={onClose}
          disabled={saving}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}

// Hilfsfunktion TeamsLink zu generieren
function normalizeTeamsLink(link) {
  if (!link) return "";
  let out = link.trim();
  // Tippfehler wie wwww.teams.de zu www.teams.de
  out = out.replace(/^wwww\./i, "www.");
  // Immer mit https:// starten
  if (!/^https?:\/\//i.test(out)) {
    out = "https://" + out;
  }
  // Optional: Prüfe, ob ein echter Teams-Link!
  // if (!out.includes("teams.microsoft.com")) out = ""; // Optional, um wirklich NUR Teams zu erlauben
  return out;
}

// Hauptkomponente
export default function AdminCourseRegistrations() {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedReg, setSelectedReg] = useState(null);

  // List laden
  const loadRegistrations = () => {
    setLoading(true);
    fetch("https://www.denisbitter.de/stage01/api/get_all_course_registrations_with_material.php")
      .then(res => res.json())
      .then(data => {
        setRegistrations(data.data || []);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadRegistrations();
  }, []);

  if (loading) {
    return <div className="text-center p-10">Lade...</div>;
  }

  return (
    <PaperBG>
      <div className="max-w-3xl mx-auto p-6 bg-gray-800 rounded-lg font-mono">
        <h1 className="text-xl text-brand text-center border border-gray-900 rounded-lg mb-6">
          Registrierte Kurse
        </h1>
        <ul className="space-y-3">
          {registrations.map(reg => (
            <li
              key={reg.registration_id}
              className=" bg-[#151515] p-3 rounded border border-gray-700 flex justify-between items-center"
            >
              <div>
                <div className="font-bold">
                  {reg.first_name} {reg.name}
                </div>
                <div className="text-sm">
                  Kurs: <span className="text-yellow-300">{reg.course_title}</span>
                </div>
                <div className="text-xs text-gray-300">
                  Start: {reg.custom_date ? new Date(reg.custom_date).toLocaleDateString("de-DE") : "unbekannt"}
                </div>
              </div>
              <div>
                {reg.material_id ? (
                  <button
                    className="bg-orange-500 hover:bg-yellow-600 text-black px-2 py-1 rounded text-xs"
                    onClick={() => setSelectedReg(reg)}
                  >
                    Bearbeiten
                  </button>
                ) : (
                  <button
                    className="bg-green-500 hover:bg-green-600 text-black px-2 py-1 rounded text-xs"
                    onClick={() => setSelectedReg(reg)}
                  >
                    Material anlegen
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
      {/* Materialeditor als Modal */}
      {selectedReg && (
        <MaterialEditor
          reg={selectedReg}
          onClose={() => setSelectedReg(null)}
          onSaved={() => {
            setSelectedReg(null);
            loadRegistrations();
          }}
        />
      )}
    </PaperBG>
  );
}
